import { createContext, useContext } from 'react';

import type { AuthUser } from '../lib/types';

/**
 * Kontext prihlásenia vo vlastnom module, oddelený od `useAuth.tsx`.
 *
 * `useIsGuest` sa pýta sem a nie cez `useAuth`: testy komponentov bežne
 * nahrádzajú celý modul `useAuth` atrapou a komponenty sa vykresľujú aj bez
 * AuthProvidera. Otázka „je to hosť?" tam nemá padnúť, iba odpovedať „nie".
 */
export type AuthContextValue = {
  user: AuthUser | null;
  loading: boolean;
  csrfToken: string | null;
  streakDays: number;
  generalUnread: number;
  pushConfigured: boolean;
  mustChangePassword: boolean;
  login: (username: string, password: string) => Promise<void>;
  changePassword: (newPassword: string, currentPassword?: string) => Promise<void>;
  refresh: () => Promise<void>;
  logout: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

/** Kontext bez výnimky mimo AuthProvidera (vtedy null). */
export const useOptionalAuth = (): AuthContextValue | null => useContext(AuthContext);
